var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms"},[_c('LayoutFrontTopbar'),_c('LayoutAdminSidebar'),_c('section',{staticClass:"cms-main"},[_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }